import { memo, useCallback } from 'react';
import parse from 'html-react-parser';

import { sessionAtom, useValue } from '@/store';

import { addEvent } from '@/modules/api';
import { useTheme } from '@/modules/common';
import { EventType } from '@/modules/models';

import { Button, Icon } from './PromptButton.styles';

interface PromptButtonProps {
  children?: React.ReactNode;
  icon?: string;
  prompt: string;
  disabled?: boolean;
  eventName?: EventType;
}

export const PromptButton = memo<PromptButtonProps>(({ children, icon, prompt, disabled, eventName }) => {
  const { isRtl } = useTheme();

  const session = useValue(sessionAtom);
  const onClick = useCallback(() => {
    window.sayWhattChat.sendNewMessage(prompt);

    if (eventName) {
      addEvent({
        type: eventName,
        userSession: session,
        metadata: {},
      });
    }
  }, [eventName, prompt, session]);

  return (
    <Button disabled={disabled} onClick={onClick}>
      {icon && <Icon isRtl={isRtl} src={icon} alt={children?.toString()} />}
      <span>{parse(String(children))}</span>
    </Button>
  );
});
